import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopReceiptsMessages = defineMessages("desktop-receipts", en);
